class CompatibilityService {
    constructor($rootScope, compatibilityUpgradedService, subscriptionService, logService) {
        this.logger = logService.createLoggerWithSource('CompatibilityService');
        this.rootSubscription = subscriptionService.createSubscription();

        this.rootSubscription.add(
            compatibilityUpgradedService.scopeEvent$.subscribe({
                next: ({ message, ...restArgs }) => {
                    $rootScope.$broadcast(message, ...Object.values(restArgs));
                },
                error: err => {
                    this.logger.error('compatibilityService#scopeEvent$', err);
                }
            })
        );

        $rootScope.$on('$destroy', this.onScopeDestroyed);
    }

    onScopeDestroyed() {
        subscriptionService.endSubscription(this.rootSubscription);
    }
}

firebird.factory('compatibilityService', [
    '$rootScope',
    'compatibilityUpgradedService',
    'subscriptionService',
    'logService',
    (...deps) => new CompatibilityService(...deps)
]);
